module.exports = __webpack_public_path__ + "static/media/taco.96b92ca9.png";